import * as React from "react";
import { useSyncExternalStore as useSyncExternalStoreShim } from "use-sync-external-store/shim";

// Polyfill useId for React 16
let idCounter = 0;
const useId = () => {
    const ref = React.useRef(null);
    if (ref.current === null) {
        ref.current = `:r${idCounter++}:`;
    }
    return ref.current;
};

// Export all React APIs plus polyfills
export * from "react";
export { useId, useSyncExternalStoreShim as useSyncExternalStore };
export default React;
